import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:6061/";

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Function to check if the token is expired
const isTokenExpired = (token) => {
  if (!token) return true; // No token means expired
  const { exp } = JSON.parse(atob(token.split('.')[1])); // Decode the JWT
  return Date.now() >= exp * 1000; // Convert exp to milliseconds
};

// Request interceptor
// api.interceptors.request.use(
//   async (config) => {
//     const token = await getToken();
//     if (token && !isTokenExpired(token)) {
//       config.headers["x-access-token"] = token;
//     }
//     else{
//       localStorage.clear()
//     }
//     return config;
//   },
//   (error) => {
//     console.log("prev error",error)
//   }
// );

// // Response interceptor
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const { response } = error;
//     // Handle token expiration or unauthorized access
//     if((response && response.data.isExpired) || (response && response === undefined) || (response && response.data.isAvailable === false) || (response && response.data.success === false)){
//         localStorage.clear(); 
//     }
//     return Promise.resolve();
//   }
// );


api.interceptors.response.use(
  (response) => response, // Pass the response as is when it's successful
  (error) => {
    const { response } = error;
    // Handle token expiration, unauthorized access, or any other error indicating failure
    if (response) {
      if (response.status === 403 || response.data.isExpired || response.data.isAvailable === false || response.data.success === false) {
        // Clear the localStorage (remove token and credentials)
        localStorage.clear();
        // Redirect to the login page if the token is expired or invalid
        window.location.href = '/login'; // Redirect to login page
      }
    }

    // Return a rejected promise so that other parts of the app can handle the error
    return Promise.reject(error);
  }
);
